// 简易深拷贝
export const deepCopy = (source) => {
  try {
    return JSON.parse(JSON.stringify(source));
  } catch {
    return null
  }
}

// 格式化日期
export const formatTime = function (time, fmt) { // author: meizz
  var _time = new Date(time)
  if (!_time) return ''
  var o = {
    'M+': _time.getMonth() + 1, // 月份
    'd+': _time.getDate(), // 日
    'h+': _time.getHours(), // 小时
    'm+': _time.getMinutes(), // 分
    's+': _time.getSeconds(), // 秒
    'q+': Math.floor((_time.getMonth() + 3) / 3), // 季度
    'S': _time.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (_time.getFullYear() + '').substr(4 - RegExp.$1.length)) }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  }
  return fmt
}
/*
对象合并
* @param {Object} target 目标对象。
* @param {Object} source 源对象。
* @param {boolean} deep 是否复制(继承)对象中的对象。
* @returns {Object} 返回继承了source对象属性的新对象。
*/
export const objectExtend = (target, source, deep) => {
  target = target || {}
  var sType = typeof source; var i = 1; var options
  if (sType === 'undefined' || sType === 'boolean') {
    deep = sType === 'boolean' ? source : false
    source = target
    target = this
  }
  if (typeof source !== 'object' && Object.prototype.toString.call(source) !== '[object Function]') { source = {} }
  while (i <= 2) {
    options = i === 1 ? target : source
    if (options != null) {
      for (var name in options) {
        var src = target[name]; var copy = options[name]
        if (target === copy) { continue }
        if (deep && copy && typeof copy === 'object' && !copy.nodeType) {
          target[name] = objectExtend(src ||
            (copy.length != null ? [] : {}), copy, deep)
        } else if (copy !== undefined) { target[name] = copy }
      }
    }
    i++
  }
  return target
}

function S4 () {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}
export const guid = () => {
  return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4())
}

/**
 *  添加 Storage
 * @param {*} key 存储数据的key
 * @param {*} data 存储的数据
 * @param {*} expire  有效时长。单位ms 非必传
 */
export const setLocal = (key, data, expire = null) => {
  let storage = {}
  storage.data = data
  storage.time = (new Date()).getTime()
  if (expire) {
    storage.expire = expire
  }
  localStorage.setItem(key, JSON.stringify(storage))
}

/**
 *  添加 Storage
 * @param {*} key 存储数据的key
 */
export const getLocal = (key) => {
  let storage = JSON.parse(localStorage.getItem(key)) || {}
  let expire = storage.expire || 0
  let time = storage.time || 0
  let now = (new Date()).getTime()

  if (!expire || now <= time + expire) {
    return storage.data
  } else {
    return ''
  }
}

export const hasFlag = (param) => {
  if (!param || !Array.isArray(param)) {
    return false
  }
  if (param.find(item => item.key === '国家' && item.icon)) {
    return true
  } else {
    return false
  }
}

export const getTextByValue = (value, map) => {
  if (Array.isArray(map)) return ''
  for (var i = 0; i < map.length; i++) {
    var item = map[i]
    if (item.value === value) {
      return item.text
    }
  }
  return ''
}

export const getProductParamList = (param = []) => {
  if (!param || !Array.isArray(param)) {
    return []
  }
  var paramList = param.filter(function (item) {
    return (item.key !== '国家')
  })
  return paramList || []
}

export const getServerTime = () => {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.open("HEAD", location.href, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        resolve(new Date(xhr.getResponseHeader("Date")))
        console.log(xhr)
      }
    }
    xhr.send(null);
  })
}

export const getDate = () => new Promise((resolve, reject) => {
  var xhr = null;
  if (window.XMLHttpRequest) {
    xhr = new window.XMLHttpRequest();
  } else { // ie
    // eslint-disable-next-line no-undef
    xhr = new ActiveObject("Microsoft")
  }
  xhr.open("GET", "/", true);
  xhr.send(null);
  xhr.onreadystatechange = function () {
    var time, date;
    if (xhr.readyState == 2) {
      time = xhr.getResponseHeader("Date");
      date = new Date(time);
      resolve(date)
      console.log(date);
    }
  }
})
